export default __webpack_public_path__ + "static/media/img-0582-iceland-premium-face.5a7f9176.png";